<template>
  <div>
    <div v-if="!isShow" class="intent-item z-border-red" style="padding: 10px 15px 10px;">
      <v-layout wrap>
        <v-flex xs12 sm10 class="pa-2 text-xs-left">
          <v-layout wrap>
            <v-flex xs3 class="primary-color pb-2 text-xs-right"
              ><h3>{{ $t('auction_name') }} :</h3></v-flex
            >
            <v-flex xs9 style="color:#000; align-self: center;" class="pl-2">{{
              auctionItem.auction_title
            }}</v-flex>
            <v-flex xs3 class="primary-color text-xs-right"
              ><h3>{{ $t('post_name') }} :</h3></v-flex
            >
            <v-flex xs9 style="color:#000; align-self: center;" class="pl-2">{{
              postidlist
            }}</v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12 sm2 class="text-xs-right">
          <v-btn fab outline color="primary" class="extra-small ma-1" @click="editIntent()">
            <i class="fas fa-pencil-alt"></i>
          </v-btn>
          <v-btn
            fab
            outline
            :loading="loadingDelete"
            color="primary"
            class="extra-small ma-1"
            @click="deleteLiveAuctionByID(auctionItem)"
          >
            <i class="fa fa-trash middle"></i>
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
    <auction-form
      v-else
      @currentViewDashBoard="currentViewDashBoard"
      @setAuctionId="setAuctionId"
      @getLiveAuction="$emit('getLiveAuction')"
      :isShow.sync="isShow"
      :isEdit.sync="isShow"
      v-model="auctionItem"
    ></auction-form>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import AuctionForm from '@/components/view/liveAuction/AuctionForm'
export default {
  props: {
    value: {
      default: null
    },
    itemEdit: {
      default: null
    }
  },
  components: {
    AuctionForm
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    postidlist() {
      const vm = this
      if (vm.auctionItem && vm.auctionItem.postidlist) {
        return JSON.parse(vm.auctionItem.postidlist).name
      }
    }
  },
  mounted() {},
  data: function() {
    return {
      isShow: this.value,
      auctionItem: this.itemEdit,
      loadingDelete: false
    }
  },
  methods: {
    currentViewDashBoard(page) {
      const vm = this
      vm.$emit('currentViewDashBoard', page)
    },
    setAuctionId(auctionId) {
      const vm = this
      vm.$emit('setAuctionId', auctionId)
    },
    editIntent() {
      const vm = this
      vm.isShow = true
    },
    async deleteLiveAuctionByID(item) {
      const vm = this
      let result = await vm.$swal.fire({
        title: vm.$t('Do you want to delete {name}?', {
          name: item.auction_title
        }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        vm.loadingDelete = true
        let res = await api.deleteLiveAuctionByID({
          pageid: vm.selectedBot.pageid,
          auctionID: item.id
        })
        if (res.success) {
          vm.$swal.fire({
            title: vm.$t('Successfully'),
            text: `${item.auction_title} ถูกลบแล้ว`,
            type: 'success'
          })
          vm.$emit('getLiveAuction')
          vm.loadingDelete = false
        } else {
          vm.$swal.fire({
            title: vm.$t('Unsuccessful'),
            type: 'error'
          })
          vm.loadingDelete = false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/components/view/liveAuction/AuctionEdit.vue